import React, { useState } from 'react';

const ConfirmationModalInput = ({ onDelete, id, email, isOpen, onClose, title }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleDelete = () => {
const correctPassword = process.env.REACT_APP_HIGHSECURITYPASSWORD;
    if (password === correctPassword) {
       onDelete(id, email); 
    } else {
      setError('Incorrect Super Admin Password.');

      setTimeout(()=>{
setError('');
      },2000)
    }
  };

  if (!isOpen) return null;

 return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="relative bg-white p-4 rounded-lg shadow-lg w-[500px] max-w-full">
        
        {/* Cross Icon */}
        <button
          className="absolute top-0 right-2 text-gray-600 hover:text-gray-800"
          onClick={() => {
            setPassword('');
            setError('');
            onClose();
          }}
        >
          <span className="text-2xl">&times;</span>
        </button>

        {/* Title */}
        <h3 className="text-xl font-semibold text-gray-800 text-center mb-4">{title}</h3>
        <p className="mt-2 mb-2 text-gray-600 text-center">This action cannot be undone.</p>

        <input
          type="password"
          placeholder="Enter Super Admin Password"
          className="w-full px-3 py-2 border rounded-lg mb-2"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        {error && <p className="text-red-500 text-sm mb-3">{error}</p>}

            <div className="mt-4 flex justify-center space-x-4"> 
          <button
            className="px-4 py-2 bg-gray-300 text-gray-700 rounded-lg hover:bg-gray-400 focus:outline-none"
            onClick={() => {
              setPassword('');
              setError('');
              onClose();
            }}
          >
            Cancel
          </button>
          <button
            className="px-4 py-2 bg-[#E31c23] text-white rounded-lg hover:bg-red-600 focus:outline-none transition-colors duration-200 active:bg-[#F87171]"
            onClick={handleDelete}
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModalInput;
